import React, { useState, useEffect, useCallback } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import ProjectCard from "./ProjectCard";
import axios from "axios";

const dummyProject = {
  name: null,
  description: null,
  svn_url: null,
  stargazers_count: null,
  languages_url: null,
  pushed_at: null,
};
const API = "https://api.github.com";
// const gitHubQuery = "/repos?sort=updated&direction=desc";
// const specficQuerry = "https://api.github.com/repos/hashirshoaeb/";

const Project = ({
  heading,
  username,
  length,
  specfic,
  isDarkMode,
  publicRepos,
}) => {
  const allReposAPI = `${API}/users/${username}/repos?sort=updated&direction=desc`;
  const specficReposAPI = `${API}/repos/${username}`;
  const publicReposAPI = `${API}/repos/${publicRepos?.gitHubUser}`;
  const dummyProjectsArr = new Array(4).fill(dummyProject);
  const projectSites = [
    "https://codesandbox.io/p/sandbox/react-search-box-example-cra-17ml6?file=%2Fsrc%2Findex.tsx",
    "https://movies-harp.netlify.app/",
    "https://e-commerxe.netlify.app/",
    "https://would-you-rather-fun-game.netlify.app/",
  ];

  const [projectsArray, setProjectsArray] = useState([]);
  console.log(projectsArray);

  const fetchRepos = useCallback(async () => {
    let repoList = [];
    try {
      // getting all repos
      //const response = await axios.get(allReposAPI);
      // slicing to the length
      //repoList = [...response.data.slice(0, length)];
      // adding specified repos

      try {
        for (let repoName of publicRepos?.repoName) {
          const response = await axios.get(`${publicReposAPI}/${repoName}`);
          repoList.push(response.data);
        }
      } catch (error) {
        console.error(error.message);
      }
      try {
        for (let repoName of specfic) {
          const response = await axios.get(`${specficReposAPI}/${repoName}`);
          repoList.push(response.data);
        }
      } catch (error) {
        console.error(error.message);
      }
      // setting projectArray
      // TODO: remove the duplication.
    } catch (error) {
      console.error(error.message);
    }
    repoList.forEach(
      (rpList, index) => (rpList.sitelink = projectSites[index])
    );
    //console.log(repoList)
    setProjectsArray(repoList);
  }, [allReposAPI, length, specfic, specficReposAPI]);

  useEffect(() => {
    fetchRepos();
  }, [fetchRepos]);

  return (
    <Container
      fluid
      id="projects"
      className={`${
        isDarkMode ? "background-theme-dark" : "bg-light"
      } m-0 py-5`}
    >
      {projectsArray.length ? (
        <Container className="">
          <h2
            className={`${
              isDarkMode ? "color-theme-light" : ""
            } display-4 pb-5 text-center`}
          >
            {heading}
          </h2>
          <Row>
            {projectsArray.length
              ? projectsArray.map((project, index) => (
                  <ProjectCard
                    key={`project-card-${index}`}
                    id={`project-card-${index}`}
                    value={project}
                    isDarkMode={isDarkMode}
                  />
                ))
              : dummyProjectsArr.map((project, index) => (
                  <ProjectCard
                    key={`dummy-${index}`}
                    id={`dummy-${index}`}
                    value={project}
                    isDarkMode={isDarkMode}
                  />
                ))}
          </Row>
        </Container>
      ) : (
        ""
      )}
    </Container>
  );
};

export default Project;
